/* RBP-POPUP-START v1.0 (24-10-2026) | Roborro signup popup | ROBO7KX | Klaviyo list ULhwgd (Welcome) | kopie ML-popup v2 (live) */
(function () {
  'use strict';
  var KEY = 'rb_popup_v1';
  var DAY = 86400000;
  var qs = location.search;
  var FORCE = /[?&](?:rbpopup=(?:force|ebf)|ebf=1)/.test(qs);   /* 24-10: ?rbpopup=ebf of ?ebf=1 = test, altijd tonen */
  var path = location.pathname.toLowerCase();
  /* 25-10 Lenn: 35 s na BINNENKOMST op de site (sessie), niet per pagina. Start telt ook op pagina's waar de pop-up niet mag */
  var SES_START = Date.now();
  try { var ss0 = parseInt(sessionStorage.getItem('popup_sessie_start'), 10);
    if (ss0 > 0 && ss0 <= SES_START) SES_START = ss0; else sessionStorage.setItem('popup_sessie_start', String(SES_START)); } catch (eSS) {}

  /* never on these paths (with or without locale prefix) */
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|account|pages|policies)(?:\/|$)/.test(path)) return;
  if (path.indexOf('/checkouts') !== -1 || path.indexOf('/apps/') !== -1) return;
  /* not for visitors arriving from our own mails */
  if (!FORCE && /utm_source=klaviyo/i.test(qs)) return;

  function st() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  /* 24-10: aanmelding via de footer (Shopify-nieuwsbrief) telt als aangemeld: pop-up komt dan niet meer */
  if (/customer_posted=true/.test(qs + location.hash)) { var S0 = st(); S0.done = Date.now(); save(S0); }
  document.addEventListener('submit', function (ev) { try { var f = ev.target; if (!f || f.id === 'RBP-form') return;
    var ft = f.querySelector('input[name="form_type"]'); var ce = f.querySelector('input[name="contact[email]"],input[type="email"]');
    if (ft && ft.value === 'customer' && ce && ce.value) { var s9 = st(); s9.done = Date.now(); save(s9); } } catch (e9) {} }, true);
  var S = st(), now = Date.now();
  if (!FORCE) {
    if (S.done && now - S.done < 365 * DAY) return;
    if (S.until && now < S.until) return;
  }

  /* taal = Shopify.locale (markt-URL); zonder prefix = wortelmarkt 'de'. lb (Luxemburg) = de */
  var seg = (path.split('/')[1] || '');
  var segMap = {};
  var lang = null;
  var srcLoc = /^[a-z]{2}-[a-z]{2}$/.test(seg) ? seg : 'de';

  function init() {
    var dictEl = document.getElementById('RBP-i18n');
    var card = document.getElementById('RBP-card');
    var back = document.getElementById('RBP-backdrop');
    if (!dictEl || !card || !back) return;
    var I18N; try { I18N = JSON.parse(dictEl.textContent); } catch (e) { return; }
    if (!lang) {
      var sl = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').split('-')[0].toLowerCase();
      if (sl === 'lb') sl = 'de';
      lang = I18N[sl] ? sl : (I18N['de'] ? 'de' : 'en');
    }
    var T = I18N[lang] || I18N.en;
    function put(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
    put('RBP-title', T.title); put('RBP-sub', T.sub);
    put('RBP-fn-l', T.fn); put('RBP-em-l', T.em);
    put('RBP-t-ml', T.min); put('RBP-t-sl', T.sec);
    put('RBP-go', T.cta); put('RBP-no', T.no);
    put('RBP-s-title', T.stitle); put('RBP-s-note', T.snote); put('RBP-s-btn', T.sbtn);
    put('RBP-copy-t', T.copy);
    put('RBP-l1', T.lpre); put('RBP-llink', T.llink); put('RBP-l2', T.lpost);
    var ppHref = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'policies/privacy-policy';
    document.getElementById('RBP-llink').setAttribute('href', ppHref);
    document.getElementById('RBP-x').setAttribute('aria-label', T.close);

    if (window.RBP_EBF) { try { window.RBP_EBF(T, lang, card); } catch (eE) {} }   /* 24-10: Early Black Friday-laag (snippet rb-popup-ebf) */
    /* countdown 03:00, stops at 0:00, form stays usable */
    var left = 180, tick = null;
    function renderT() {
      var m = Math.floor(left / 60), s = left % 60;
      put('RBP-t-m', (m < 10 ? '0' : '') + m);
      put('RBP-t-s', (s < 10 ? '0' : '') + s);
    }
    function startTimer() {
      renderT();
      tick = setInterval(function () {
        left -= 1;
        if (left <= 0) { left = 0; clearInterval(tick); }
        renderT();
      }, 1000);
    }

    var shown = false, prevFocus = null, prevOverflow = '';
    function open() {
      if (shown) return; shown = true;
      prevFocus = document.activeElement;
      back.hidden = false; card.hidden = false;
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        back.className = 'rbp-on'; card.classList.add('rbp-on');
      }); });
      startTimer();
      /* lightweight shown counter (local only; Klaviyo client/events is CORS-blocked, see report) */
      var s = st(); s.shown = (s.shown || 0) + 1; s.lastShown = Date.now(); save(s);
      document.addEventListener('keydown', onKey, true);
    }
    function close(dismiss) {
      back.className = ''; card.classList.remove('rbp-on');
      document.documentElement.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey, true);
      if (tick) clearInterval(tick);
      setTimeout(function () { back.hidden = true; card.hidden = true; }, 330);
      if (prevFocus && prevFocus.focus) { try { prevFocus.focus(); } catch (e) {} }
      if (dismiss) {
        var s = st(); s.n = (s.n || 0) + 1;
        s.until = Date.now() + (s.n >= 2 ? 30 : 7) * DAY;
        save(s);
      }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(true); return; }
      if (e.key !== 'Tab') return;
      var f = card.querySelectorAll('button,input,[href]');
      var v = []; for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) v.push(f[i]); }
      if (!v.length) return;
      var first = v[0], last = v[v.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    back.addEventListener('click', function () { close(true); });
    document.getElementById('RBP-x').addEventListener('click', function () { close(true); });
    document.getElementById('RBP-no').addEventListener('click', function () { close(true); });
    document.getElementById('RBP-s-btn').addEventListener('click', function () { close(false); });

    /* copy code: clipboard API + select-on-tap fallback */
    var copyBtn = document.getElementById('RBP-copy');
    copyBtn.addEventListener('click', function () {
      var code = document.getElementById('RBP-code').textContent.trim();
      function ok() {
        var t = document.getElementById('RBP-copy-t');
        t.textContent = T.copied;
        setTimeout(function () { t.textContent = T.copy; }, 2000);
      }
      function fallback() {
        var el = document.getElementById('RBP-code');
        try {
          var rng = document.createRange(); rng.selectNodeContents(el);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(rng);
          if (document.execCommand && document.execCommand('copy')) ok();
        } catch (e) {}
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok, fallback);
      } else { fallback(); }
    });

    /* submit via legacy kmail endpoint (form-encoded = simple request, no CORS preflight; proven in POPUP_REPORT.md) */
    var form = document.getElementById('RBP-form');
    var err = document.getElementById('RBP-err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = document.getElementById('RBP-em').value.trim();
      var fn = document.getElementById('RBP-fn').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) {
        err.textContent = T.err; err.classList.add('rbp-show'); return;
      }
      err.classList.remove('rbp-show');
      var btn = document.getElementById('RBP-go');
      btn.disabled = true;
      var body = 'g=ULhwgd&company_id=SfC5Km' +
        '&email=' + encodeURIComponent(em) +
        '&first_name=' + encodeURIComponent(fn) +
        '&%24source=' + encodeURIComponent('Roborro Popup ' + srcLoc) +
        '&ml_taal=' + encodeURIComponent(lang || '') + '&%24fields=%24source%2Cfirst_name%2Cml_taal';
      function succeed() {
        form.classList.add('rbp-hide');
        document.getElementById('RBP-success').classList.add('rbp-show');
        if (tick) clearInterval(tick);
        var s = st(); s.done = Date.now(); save(s);
        try { document.getElementById('RBP-s-btn').focus({ preventScroll: true }); } catch (e2) {}
      }
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        body: body
      }).then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
        .then(function (j) {
          btn.disabled = false;
          if (j && j.success !== false) { succeed(); }
          else { err.textContent = T.err; err.classList.add('rbp-show'); }
        })
        .catch(function () { btn.disabled = false; err.textContent = T.err; err.classList.add('rbp-show'); });
    });

    function maybeOpen() {
      try {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          /* popup_protectie_2710 Lenn: shipping protection telt niet als product in de cart (app zet die er soms zelf in) */
          var PR = new RegExp("shipping protection|package protection|order protection|parcel protection|insured shipping|envoi assur\u00e9|envoi assure|livraison assur\u00e9e|verzekerde verzending|verzekerd verzenden|versicherter versand|versandschutz|paketschutz|env\u00edo asegurado|envio asegurado|spedizione assicurata|forsikret forsendelse|f\u00f6rs\u00e4krad frakt|ubezpieczona wysy\u0142ka|ubezpieczona przesy\u0142ka|poji\u0161t\u011bn\u00e1 doprava|poji\u0161t\u011bn\u00e1 z\u00e1silka|livrare asigurat\u0103|vakuutettu toimitus|apdraustas siuntimas|protezione spedizione|forsendelsesbeskyttelse|versandversicherung|verzendbescherming|protection d.exp[\u00e9e]dition|protecci[\u00f3o]n de env[\u00edi]o|ochrona przesy[\u0142l]ki|fraktskydd|ochrana z[\u00e1a]silky|toimitussuoja|protec[\u021bt]ia livr[\u0103a]rii", 'i'), PT = ["shipping protection", "slidecart - shipping protection", "snap cart drawer - shipping protection"], PI = ["10198163980616", "9831720911176"];
          var echt = 0; ((c && c.items) || []).forEach(function (it) { var t = [it.title, it.product_title, String(it.handle || '').replace(/[-_]+/g, ' ')].join(' ');
            if (PR.test(t) || PT.indexOf(String(it.product_type || '').trim().toLowerCase()) > -1 || PI.indexOf(String(it.product_id)) > -1) return; echt += (it.quantity || 1); });
          if (c && !c.items && c.item_count > 0) return;
          if (echt > 0) return;
          open();
        }).catch(function () { open(); });
      } catch (e) { open(); }
    }
    /* trigger: 25s met cart-check; desktop exit intent */
    if (FORCE) { open(); return; }
    var rest = 35000 - (Date.now() - SES_START);   /* 25-10: resterende sessietijd; al voorbij = na 1,5 s, nooit direct bij laden */
    setTimeout(maybeOpen, rest > 1500 ? rest : 1500);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(min-width:768px)').matches) maybeOpen();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* RBP-POPUP-END */
